import React, { forwardRef, useState } from 'react'
import useAccessibleDrop from '../hooks/useAccessibleDrop'
import useDragAndDropContext from '../hooks/useDragAndDropContext'

const DefaultTarget = forwardRef((props, ref) => {
  return <div ref={ref} data_component_id='DefaultTarget' className={props.className}>{props.children}</div>
})

const DropArea = (props) => {

  
  const {
    target:Target = DefaultTarget,
    allowedTypes = 'default', // special case "*"?
    style,
    onDrop,
    className,
    onLimitReachedDrop = (item) => {console.log("Limit reached with item ("+item+") on Drop"); },
    data
  } = props

  const {
    onLimitReachedHover = () => false,
  } = useDragAndDropContext()

  const dS = data?.dS || []
  const sourceLimit = data?.sourceLimit || -1

  // const [limitReached, setLimitReached] = useState(false)
  
  const allowDropCheck = () =>  sourceLimit === -1 ? true : dS.length < sourceLimit ? true : onLimitReachedHover()
  
  const onSourceDrop = (item) => {
    if (sourceLimit === -1 || dS.length < sourceLimit) return onDrop(item)
    onLimitReachedDrop(item)
  }

  const [{ isOver, canDrop, dropId }, drop] = useAccessibleDrop({
    accept: allowedTypes, // if "*" go to the manager find the list of types and add them all here. By default there will be just one 'default'.
    zone: {
      data
    },
    // canDrop function its called when you start dragging
    canDrop: allowDropCheck,
    drop: (item) => {
      onSourceDrop(item)
    },
    collect: (monitor) => ({
      isOver: monitor.isOver(),
      canDrop: monitor.canDrop(),
      dropId: monitor.getHandlerId()
    })
  })

  const isActive = canDrop && isOver

  const addAddtionalStates = (data) => {
    let newData = {...data}
    if (isActive) {
      newData.aS += ' active'
    } else if (canDrop) {
      newData.aS += ' canDrop'
    }
    return (newData)
  }


  return (
    <Target ref={drop} className={`${className?className:''}`} style={style} data={addAddtionalStates(data)} dnd_id={`_${dropId}`}> 
      {props.children}
    </Target>
  )
}

export default DropArea